import storeEvent from '../../utils/store-event';
import { get, clone } from '../../utils/object-helpers';

export default class {
    onCreate(input) {
        this.state = {
            navOpen: false,
            cards: this.formatCards(input)
        };
    }
    onInput(input) {
        this.state.cards = this.formatCards(input);
    }
    onMount() {
        const navBar = document.querySelector('nav.open');
        if (navBar) {
            this.state.navOpen = true;
        }

        storeEvent.toggleLeftNavDone.listen(data => {
            this.state.navOpen = !!data.isOpen;
        });
    }
    formatCards(input) {
        const cards = clone(get(input, 'containers.0.cards', []));
        if (cards.length === 1 || cards.length === 3) {
            /*
                These mutations are passed to the item card to be processed in a single pass
                We need these particular mutations for promoted items when there is either one or 3 items,
                the reason is that the first item will change the layout to have the image at the left and
                all the item's details at the right.
             */
            cards[0].itemPropertyOrdering._mutations = [
                { propertyName: 'title', newSection: 'primary' },
                { propertyName: '__search.titleTags', newSection: 'primary' },
                { propertyName: '__signal', newSection: 'primary' }
            ];
        }
        return cards;
    }
}
